import {CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode} from '@angular/core';
import {environment, setEnvironmentToProd} from '../../environments/environment';
import {PdfToolsComponent} from './pdf-tools.component';
import {FileUploadComponent} from './file-upload/file-upload.component';
import {FileViewerComponent} from './file-viewer/file-viewer.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FileSelectionComponent} from './file-selection/file-selection.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCardModule,
        MatListModule,
        MatInputModule,
        MatIconModule,
        MatChipsModule,
        MatExpansionModule,
        MatTableModule,
        MatSelectModule,
        MatDialogModule,
        MatButtonModule,
        MatSortModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatMenuModule,
        MatTooltipModule,
        PdfToolsComponent,
        FileUploadComponent,
        FileViewerComponent,
        FileSelectionComponent
    ],
    exports: [
        MatFormFieldModule,
        MatCardModule,
        MatListModule,
        MatInputModule,
        MatIconModule,
        MatChipsModule,
        MatExpansionModule,
        MatTableModule,
        MatSelectModule,
        MatDialogModule,
        MatButtonModule,
        MatSortModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatMenuModule,
        MatTooltipModule,
        PdfToolsComponent,
        FileUploadComponent,
        FileViewerComponent,
        FileSelectionComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: []
})
export class PdfToolsModule {
  constructor() {
    console.log('initializing PDF Tools');
    if (!isDevMode()) {
      setEnvironmentToProd();
    }
  }
}
